import React from 'react'

class CheckMarkBadge extends React.Component {
  render() {
    return (
      <svg className="checkMarkBadge" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="nonzero">
          <path
            className="background"
            fill="#64B512"
            d="M12 21.257L7.025 24.01l-1.57-5.464-5.465-1.571L2.743 12-.01 7.025l5.464-1.57L7.025-.01 12 2.743 16.975-.01l1.57 5.464 5.465 1.571L21.257 12l2.753 4.975-5.464 1.57-1.571 5.465z"
          />
          <path className="check" stroke="#FFF" strokeWidth="2" d="M7.5 11.881L10.546 15 16.5 9" />
        </g>
      </svg>
    )
  }
}

export default CheckMarkBadge
